import React from 'react'
import './modalWindowStorageContact.css'
import FaClose from 'react-icons/lib/fa/close'

const modalWindowStorageContact = (props) => {
    return (
        <div className="modalWindowStorageContact">
            <div onClick={props.contactSwitchToHidden} name="contact">{props.contactName}</div>
            <button onClick={props.contactModalClose}><FaClose/></button>
        </div>
    )
}

export default modalWindowStorageContact;


// WEBPACK FOOTER //
// ./src/common/chat/modalWindowStorage/modalWindowStorageContact/modalWindowStorageContact.js